import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./palaciodas_delicias_button.module.scss";

interface PalaciodasDeliciasButtonProps {
  href: string;
  title: string;
  icon: ReactNode;
  isInternal?: boolean;
}

const PalaciodasDeliciasButton: React.FC<PalaciodasDeliciasButtonProps> = ({
  href,
  title,
  icon,
  isInternal = false,
}) => {
  const navigate = useNavigate();

  const content = (
    <div className={styles.content}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.spacer} />
    </div>
  );

  if (isInternal) {
    return (
      <button
        type="button"
        className={styles.button}
        onClick={() => navigate(href)}
      >
        {content}
      </button>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={styles.button}
    >
      {content}
    </a>
  );
};

export default PalaciodasDeliciasButton;
